import React from 'react';
import { Link } from 'react-router-dom';

const Place = ({ place, half }) => {
  const { imageSrc, name } = place;
  return (
    <a
      href={`places/${name}`}
      className={`${half ? 'place-link-half' : ''} group place-link `}
    >
      <img alt={name} className="place-img" src={imageSrc} />
      <div className="place-title">
        <h4>{name}</h4>
      </div>
    </a>
  );
};

export default Place;
